var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3766_11878)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 8,
    fill: "#E6E7EB"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.4 9.9C8.4 9.07157 9.07157 8.4 9.9 8.4C10.7284 8.4 11.4 9.07157 11.4 9.9C11.4 10.7284 10.7284 11.4 9.9 11.4C9.07157 11.4 8.4 10.7284 8.4 9.9ZM9.9 9.6C9.73431 9.6 9.6 9.73431 9.6 9.9C9.6 10.0657 9.73431 10.2 9.9 10.2C10.0657 10.2 10.2 10.0657 10.2 9.9C10.2 9.73431 10.0657 9.6 9.9 9.6Z",
    fill: "#F8009E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 7.8C6 6.80589 6.80589 6 7.8 6H16.2C17.1941 6 18 6.80589 18 7.8V16.2C18 17.1941 17.1941 18 16.2 18H7.8C6.80589 18 6 17.1941 6 16.2V7.8ZM7.8 7.2C7.46863 7.2 7.2 7.46863 7.2 7.8V16.2C7.2 16.4573 7.36196 16.6768 7.58949 16.762L13.9758 10.3757C14.2101 10.1414 14.59 10.1414 14.8243 10.3757L16.8 12.3514V7.8C16.8 7.46863 16.5314 7.2 16.2 7.2H7.8ZM16.8 14.0485L14.4 11.6485L9.24857 16.8H16.2C16.5314 16.8 16.8 16.5314 16.8 16.2V14.0485Z",
    fill: "#F8009E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3766_11878"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconImage);
export default __webpack_public_path__ + "static/media/icon-image.ba2edbea7def9d18bd1d3dd3223d98db.svg";
export { ForwardRef as ReactComponent };